/* oxlint-disable lingui/no-unlocalized-strings */
// Don't translate for single language organizations
import { Text } from "@medoma/components/Text/Text";

export const GuideTemplateCapioAhcNacka = () => (
  <>
    <Text element="p">
      Hemma hos dig kan vi erbjuda lika avancerade behandlingar som på sjukhus.
      Vi kan till exempel ge smärtlindring, intravenöst dropp, antibiotika och
      erbjuda samtalsstöd. Utöver detta kan vi hjälpa till med anpassningar av
      din bostad och ge råd om hjälpmedel som kan underlätta vardagen.
    </Text>
    <Text element="p">
      Vi på ASIH är specialiserade på att ge vård i hemmet till dig med behov av
      avancerade sjukvårdsinsatser. Hos oss är du inskriven så länge ditt
      vårdbehov inte kan tillgodoses genom vårdcentralens hemsjukvård och där
      alternativet annars är inneliggande sjukhusvård.
    </Text>
    <Text element="p">
      Vi finns tillgängliga dygnets alla timmar. Vi arbetar flexibelt och gör
      vårt yttersta för att tillgodose både dina planerade och akuta behov.
    </Text>
    <Text element="p">
      Allt ansvar som vårdcentralen tidigare har haft för dig, tar vi på ASIH
      över när du skrivs in hos oss. ASIH-vården är kostnadsfri.
    </Text>
    <Text element="p">Välkommen att kontakta oss!</Text>
    <Text element="p">Telefon: 08-718 65 27</Text>
    <Text element="p">Chatt: Tillgänglig direkt här i appen</Text>
  </>
);
